export default __webpack_public_path__ + "static/media/scenario-a-progress-expanded.90052342.png";